import Popup from "ol-ext/overlay/Popup";
import "ol-ext/dist/ol-ext.css";
import { MyMap } from "../Components/Map/View/MyMap";

export const mapPopup = new Popup({
  popupClass: "default", //"tooltips", "warning" "black" "default", "tips", "shadow",
  closeBox: false,
  positioning: "auto",
  autoPan: false,
  anim: true,
  minibar: true,
});

export const mapCursor = (type) => {
  document.getElementById("map").style.cursor = type;
};

export const changeMapSize = (containSize) => {
  MyMap.setTarget("null");
  document.getElementById("contain").style.width = containSize + "%";
  document.getElementById("mapDiv").style.left = containSize + "%";
  document.getElementById("mapDiv").style.width = 100 - containSize + "%";
  MyMap.setTarget("map");
};
